import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  establishments: [],
  loadingEstablishments: false,
};

const establishmentSlice = createSlice({
  name: "establishment",
  initialState,
  reducers: {
    loadingEstablishmentData: (state) => {
      state.loadingEstablishments = true;
    },
    loadingEstablishmentDataDone: (state) => {
      state.loadingEstablishments = false;
    },
    setEstablishmentData: (state, action) => {
      state.establishments = action.payload;
    },
  },
});

export const {
  loadingEstablishmentData,
  loadingEstablishmentDataDone,
  setEstablishmentData,
} = establishmentSlice.actions;

export default establishmentSlice.reducer;
